import React, { useState } from "react";

function ContactUs() {

  function formatDateToMySQL(date) {
    const pad = (n) => (n < 10 ? '0' + n : n);
    return (
      date.getFullYear() +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate()) +
      ' ' +
      pad(date.getHours()) +
      ':' +
      pad(date.getMinutes()) +
      ':' +
      pad(date.getSeconds())
    );
  }

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    jobTitle: "",
    companyName: "",
    telephone: "",
    message: "",
    contactTime: formatDateToMySQL(new Date()),
  });

  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage("");

    try {
      const response = await fetch(`${process.env.REACT_APP_LOGIN_API_BASEURL}/contact-us`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message || "Something went wrong!");
      }

      setResponseMessage("Your message has been sent successfully!");
      setFormData({
        fullName: "",
        email: "",
        jobTitle: "",
        companyName: "",
        telephone: "",
        message: "",
        contactTime: formatDateToMySQL(new Date())
      });
    } catch (error) {
      setResponseMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#E4EEFC] px-0 py-0 md:py-12 md:px-20">
      <div className="mx-auto p-8 rounded-lg shadow-md">
        <h2 className="text-3xl font-bold text-gray-800 text-center">Contact Us</h2>
        <p className="text-gray-600 text-center mb-6">
          Access quality candidate profiles directly from SmikRecruit
        </p>

        {responseMessage && (
          <p className={`text-center font-medium ${responseMessage.includes("success") ? "text-green-600" : "text-red-600"}`}>
            {responseMessage}
          </p>
        )}

        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Name Field */}
            <div>
              <label className="block text-gray-700 font-medium">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Enter Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-blue-500"
                required
              />
            </div>

            {/* Email Field */}
            <div>
              <label className="block text-gray-700 font-medium">
                Email ID <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter Email ID"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-blue-500"
                required
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Phone Number Field */}
            <div>
              <label className="block text-gray-700 font-medium">
                Phone Number <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="telephone"
                value={formData.telephone}
                onChange={handleChange}
                placeholder="Enter Phone Number"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-blue-500"
                required
              />
            </div>

            {/* Company Name Field */}
            <div>
              <label className="block text-gray-700 font-medium">Company Name</label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Enter Company Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-blue-500"
              />
            </div>
          </div>

          {/* Job Title Field */}
          <div>
            <label className="block text-gray-700 font-medium">
              Job Title <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="jobTitle"
              value={formData.jobTitle}
              onChange={handleChange}
              placeholder="Enter Job Title"
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-blue-500"
              required
            />
          </div>

          {/* Message Field */}
          <div>
            <label className="block text-gray-700 font-medium">
              Message <span className="text-red-500">*</span>
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              placeholder="Enter Message"
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-blue-500"
              required
            ></textarea>
          </div>

          {/* Submit Button */}
          <div className="text-center">
            <button
              type="submit"
              className="bg-blue-600 text-white px-6 py-2 rounded-md text-lg font-semibold hover:bg-blue-700 transition"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ContactUs;
